// src/admin/legal/VersionLinks.jsx — «pagina · PDF»: a version's own page and PDF on the website, in a new tab.
// ⛔ Rendered only for https:// values (the BE refuses anything else; legacy rows may hold null).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isHttpsUrl } from './legalModel.js';
import { COLORS } from '../../constants/theme.js';

const LINK = { color: COLORS.accent, textDecoration: 'none', fontSize: '13px' };

export default function VersionLinks({ row }) {
  const { t } = useTranslation('admin');
  const links = [
    { key: 'page', href: row?.url },
    { key: 'pdf', href: row?.pdf_url },
  ].filter((l) => isHttpsUrl(l.href));
  if (links.length === 0) return <span>—</span>;
  return (
    <span style={{ display: 'inline-flex', gap: '6px', alignItems: 'center' }}>
      {links.map((l, i) => (
        <React.Fragment key={l.key}>
          {i > 0 && <span aria-hidden>·</span>}
          <a href={l.href} target="_blank" rel="noopener noreferrer" style={LINK}>
            {t(`legalDocuments.links.${l.key}`)}
          </a>
        </React.Fragment>
      ))}
    </span>
  );
}
